import React, { VFC } from "react";
import styled from "styled-components";
import {
  CommentCallbackResponse,
  QaArticleEvaluationCallbackData,
  QaCommentCallbackData,
} from "~/components/modules/QaReviewCommentForm/QaReviewCommentForm";
import FullViewQAItem from "~/components/modules/qaItem/FullView";
import { Project } from "~/models/project";
import { QuestionAnswer } from "~/models/questionAnswer";
import { QuestionAnswerContentRevision } from "~/models/questionAnswer/contentRevision";
import { Topic } from "~/models/topic";
import { AnswerPreviewData } from "~/services/questionAnswers/ssrData/preview";
import AnswerReviewControlButtons from "faqSrc/components/templates/questions/questionAnswer/review/ControlButtons";

interface Props {
  answeredUser?: AnswerPreviewData["answeredUser"];
  onSubmitQaArticleEvaluation: (
    data: QaArticleEvaluationCallbackData
  ) => Promise<CommentCallbackResponse>;
  onSubmitQaReviewComment: (
    data: QaCommentCallbackData
  ) => Promise<CommentCallbackResponse>;
  project: Project;
  questionAnswer: QuestionAnswer;
  revisionStatus?: QuestionAnswerContentRevision["status"];
  task?: AnswerPreviewData["task"];
  topic: Topic;
}

const AnswerReviewPresenter: VFC<Props> = ({
  answeredUser,
  onSubmitQaArticleEvaluation,
  onSubmitQaReviewComment,
  project,
  questionAnswer,
  topic,
  revisionStatus,
  task,
}) => {
  return (
    <div>
      <Content>
        <FullViewQAItem
          answeredUser={answeredUser}
          enableReviewComment={true}
          isPreview
          onSubmitQaArticleEvaluation={onSubmitQaArticleEvaluation}
          onSubmitQaReviewComment={onSubmitQaReviewComment}
          project={project}
          questionAnswer={questionAnswer}
          reviewMode="forNormalUser"
          topic={topic}
        />
      </Content>

      <AnswerReviewControlButtons
        onSubmitQaReviewComment={onSubmitQaReviewComment}
        questionAnswer={questionAnswer}
        revisionStatus={revisionStatus}
        task={task}
        topic={topic}
      />
    </div>
  );
};

const Content = styled.div`
  margin-top: 24px;
  padding-bottom: 10px;
`;

export default AnswerReviewPresenter;
